<template>
    <rich-text-page field="careers" title="Careers">
        <template #description>Not currently shown anywhere on the website.</template>
    </rich-text-page>
</template>

<script>
    import RichTextPage from "../components/rich-text-page";

    export default {
        name: "Careers",
        components: {RichTextPage},
    }
</script>



// WEBPACK FOOTER //
// src/site-content/Careers.vue